/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useStopwatch } from 'react-timer-hook';
import {
  assignUnassignActions,
  showOverlayActions,
  ticketActions,
} from 'store/actions';
import styled from 'styled-components/macro';
import CountDownTimer from './CountDownTimer';
import { useDispatch, useSelector } from 'react-redux';
import { history } from 'store/helpers';
import { userDataSelector } from 'store/selectors';
import { ticketOnLoadIsUnassignedSelector } from 'store/selectors/ticket.selector';
interface IDurationPanel {
  userIsActive: boolean;
  setUserIsActive: Function;
  buttonClick: string | undefined;
  formTicket: any;
  setButtonClick: Function;
  hasChangeOrSaveClickedRef: { current: boolean };
}
export enum TimeTrackingStatus {
  inprogress = 'IN_PROGRESS',
  submitted = 'SUBMITTED',
  unassigned = 'UNASSIGNED',
}
const DEFAULT_MINUTES_IDLE: number = parseFloat(
  process.env.REACT_APP_MINUTES_IDLE || '0',
);
const DEFAULT_SECOND_TIMEOUT: number = parseFloat(
  process.env.REACT_APP_SECOND_TIMEOUT || '0',
);
const DurationPanel = ({
  userIsActive,
  setUserIsActive,
  formTicket,
  buttonClick,
  setButtonClick,
  hasChangeOrSaveClickedRef = { current: false },
}: IDurationPanel) => {
  const user = useSelector(userDataSelector);
  const dispatch = useDispatch();
  const stableDispatch = useCallback(dispatch, []);
  const activeUser = useRef(true);
  const lastButton = useRef('');
  useEffect(() => {
    activeUser.current = userIsActive;
  }, [userIsActive]);
  useEffect(() => {
    if (buttonClick !== undefined) {
      lastButton.current = buttonClick;
    }
  }, [buttonClick]);
  const [
    timeTrackingStatus,
    setTimeTrackingStatus,
  ] = useState<TimeTrackingStatus>(TimeTrackingStatus.unassigned);
  const timeTrackingInfo = useRef<any>();
  const [userIsIdle, setUserIsIdle] = useState(false);
  const isMyTicket = useMemo(
    () => formTicket?.ticket?.assignee?.address === user?.email,
    [formTicket?.ticket?.assignee?.address],
  );
  const {
    days,
    seconds,
    minutes,
    hours,
    start,
    pause,
    reset,
  } = useStopwatch({
    autoStart: false,
  });
  const timeDuration = useRef(0);
  const ticketOnLoadIsUnassigned = useSelector(
    ticketOnLoadIsUnassignedSelector,
  );
  const ticketOnLoadIsUnassignedRef = useRef<undefined | boolean>(
    undefined,
  );
  useEffect(() => {
    ticketOnLoadIsUnassignedRef.current = ticketOnLoadIsUnassigned;
  }, [ticketOnLoadIsUnassigned]);
  useEffect(() => {
    const rs = calculateTimeToSecond(days, hours, minutes, seconds);
    timeDuration.current = rs;
  }, [days, seconds, minutes, hours]);
  const calculateTimeToSecond = (d, h, m, s) => {
    let result = s | 0;
    result = result + m * 60;
    result = result + h * 60 * 60;
    result = result + d * 24 * 60 * 60;
    if (timeTrackingInfo.current?.durationInSeconds) {
      result = result - timeTrackingInfo?.current.durationInSeconds;
    }
    return result < 0 ? 0 : result;
  };
  /**
   * post or patch
   */
  const handleSaveTimeTracking = async (
    time,
    status,
    isDidBySystem,
  ) => {
    if (hasChangeOrSaveClickedRef.current && time === 0) return;
    if (!timeTrackingInfo?.current?.id) {
      const rs = await ticketActions.postTimeTracking(
        formTicket?.id,
        user?.email,
        status,
        time,
        '',
        isDidBySystem,
      );
      timeTrackingInfo.current = {
        ...timeTrackingInfo.current,
        id: rs.id,
      };
    } else {
      await ticketActions.patchTimeTracking(
        timeTrackingInfo?.current.id,
        timeDuration.current,
        status,
        isDidBySystem,
      );
    }
  };
  const handleGetTimeTrackingTotalDuration = async () => {
    const result = await ticketActions.postGetTimeTracking(
      formTicket?.id,
      formTicket?.ticket?.assignee?.email || user?.email,
    );
    return result;
  };
  const handlePostTimeTrackingAutoUnassign = async () => {
    ticketActions.postAutoUnassignTimeTracking(
      formTicket.id,
      0,
      'The user is unassigned by the system',
      user?.email,
    );
  };
  // -------------------------------------------------------------
  const getTotalDuration = async () => {
    const info = await handleGetTimeTrackingTotalDuration();
    timeTrackingInfo.current = info;
    setTimeTrackingStatus(info.status);
    const ss = new Date().getSeconds() + info.durationInSeconds;
    let dt: any = new Date().setSeconds(ss);
    reset(dt, false);
    if (isMyTicket) {
      start();
    } else {
      pause();
    }
  };
  useEffect(() => {
    if (userIsIdle) {
      pause();
    } else {
      start();
    }
  }, [userIsIdle]);
  useEffect(() => {
    if (!formTicket) return;
    if (
      !formTicket?.ticket?.assignee?.email &&
      !isMyTicket &&
      buttonClick !== TimeTrackingStatus.unassigned
    ) {
      // auto assign
      stableDispatch(
        assignUnassignActions.postAssignTicket(formTicket?.id),
      );
    }
    getTotalDuration();
  }, [formTicket?.id, isMyTicket]);
  // ----------------------- button control------------------
  useEffect(() => {
    if (buttonClick === TimeTrackingStatus.unassigned) {
      stableDispatch(
        showOverlayActions.show('Note', {
          ticketId: formTicket?.id,
          status: TimeTrackingStatus.unassigned,
          durationInSeconds: timeDuration.current,
        }),
      );
    }
    if (buttonClick === 'SAVE') {
      setTimeTrackingStatus(TimeTrackingStatus.inprogress);
      handleSaveTimeTracking(
        timeDuration.current,
        TimeTrackingStatus.inprogress,
        false,
      );
      // hasChangeOrSaveClickedRef.current = false;
      setButtonClick(undefined);
    }
    if (buttonClick === 'SEND_NOW') {
      setTimeTrackingStatus(TimeTrackingStatus.submitted);
      handleSaveTimeTracking(
        timeDuration.current,
        TimeTrackingStatus.submitted,
        false,
      );
      setButtonClick(undefined);
    }
  }, [buttonClick]);

  // ------------ idle Control -------------
  useEffect(() => {
    if (!formTicket?.id) return;
    console.log('idle control', {
      userIsActive,
      ticketOnLoadIsUnassigned,
    });
    if (!userIsActive) {
      // auto unassign
      if (
        !hasChangeOrSaveClickedRef.current &&
        ticketOnLoadIsUnassigned /* only auto unassign if ticket had no assignee before */
      ) {
        stableDispatch(
          assignUnassignActions.postUnassignTicket(formTicket?.id),
        );
        handlePostTimeTrackingAutoUnassign();
        localStorage.setItem('autoUnassign', formTicket?.id);
      }
      history.push(`/workdesk`);
    }
  }, [userIsActive, ticketOnLoadIsUnassigned]);
  const handleHaveNoChange = () => {
    if (lastButton.current === 'SEND_NOW') return;
    console.log('handleHaveNoChange', {
      userIsActive: activeUser.current,
      ticketOnLoadIsUnassigned: ticketOnLoadIsUnassignedRef.current,
      hasSomethingChange: hasChangeOrSaveClickedRef.current,
      lastButton: lastButton.current,
    });
    if (
      lastButton.current &&
      lastButton.current === TimeTrackingStatus.unassigned
    ) {
      console.debug(
        'do not proceed for lastButton == UNASSIGNED because already add time somewhere else',
      );
      return;
    }
    if (
      !hasChangeOrSaveClickedRef.current &&
      !ticketOnLoadIsUnassignedRef.current
    ) {
      handleSaveTimeTracking(
        timeDuration.current,
        TimeTrackingStatus.inprogress,
        true, // by system
      );
    } else if (
      hasChangeOrSaveClickedRef.current ||
      (lastButton.current &&
        lastButton.current !== TimeTrackingStatus.unassigned)
    ) {
      handleSaveTimeTracking(
        timeDuration.current,
        TimeTrackingStatus.inprogress,
        activeUser.current, // if idle -> this will be by system
      );
    } else if (
      activeUser.current &&
      lastButton.current !== TimeTrackingStatus.unassigned &&
      lastButton.current !== 'SAVE' &&
      ticketOnLoadIsUnassignedRef.current /* only auto unassign if ticket had no assignee before */
    ) {
      // auto unassign if no change
      localStorage.setItem('autoUnassign', formTicket?.id);
      handleSaveTimeTracking(0, TimeTrackingStatus.unassigned, true);
      dispatch(
        assignUnassignActions.postUnassignTicket(formTicket?.id),
      );
    }
  };
  useEffect(() => {
    if (!formTicket?.id) return;
    return () => {
      handleHaveNoChange();
    };
  }, [formTicket?.id]);
  return (
    <SContainer>
      {isMyTicket && (
        <CountDownTimer
          minutesIdle={DEFAULT_MINUTES_IDLE}
          secondTimeout={DEFAULT_SECOND_TIMEOUT}
          // minutesIdle={0.1}
          // secondTimeout={6}
          setUserIsActive={setUserIsActive}
          setUserIsIdle={setUserIsIdle}
          isAutoUnassign={
            // if onload is unassigned and made no change and never clicked save (on click save we update hasChangeOrSaveClickedRef to true )
            ticketOnLoadIsUnassigned &&
            !hasChangeOrSaveClickedRef.current
          }
        />
      )}
      {(timeTrackingStatus !== TimeTrackingStatus.submitted ||
        formTicket?.ticket?.status === 'SUCCESS') && (
        <>
          <div>Time Spent</div>
          <SLine />
          {days && <div>{days}:</div>}
          <div>{hours}</div>:
          <div>
            {`${minutes}`.length === 1 ? '0' : ''}
            {minutes}
          </div>
          :
          <div>
            {`${seconds}`.length === 1 ? '0' : ''}
            {seconds}
          </div>
        </>
      )}
    </SContainer>
  );
};
export default DurationPanel;
const SContainer = styled.div`
  background-color: #fbf8f9;
  color: #a94881;
  border-radius: 14px;
  display: flex;
  width: fit-content;
  padding: 1vh 1vw;
  font-weight: bold;
`;
const SLine = styled.div`
  border-left: 2px solid #a94881;
  margin: 0 1vw;
`;
